import React, { useMemo } from 'react'
import dayjs from 'dayjs'

const buildLookup = (defs) => {
  if (!defs || !Array.isArray(defs)) return {}
  const map = {}
  defs.forEach(d => {
    if (d.value && d.label) map[d.value] = d.label
  })
  return map
}

const formatDateValue = (d) => (d ? dayjs(d).format('MM/DD/YYYY') : '…')

const formatFilterLabel = (f, fieldLookup, utilLookup) => {
  const field = fieldLookup[f.fieldName] || f.fieldName
  if (Array.isArray(f.operator)) {
    const labels = f.operator.map(o => utilLookup[o] || o)
    return `${field}: ${labels.join(', ')}`
  }
  const op = utilLookup[f.operator] || f.operator
  if (f.value && typeof f.value === 'object') {
    if (f.value.startDate || f.value.endDate) {
      return `${field} ${op}: ${formatDateValue(f.value.startDate)} – ${formatDateValue(f.value.endDate)}`
    }
    return `${field}: ${op}`
  }
  if (f.value) return `${field} ${op} ${f.value}`
  return `${field}: ${op}`
}

const AppliedFilters = ({ requestFilters, onRemove, onClearAll, filterDefs, utilDefs }) => {
  const activeFilters = requestFilters.filter(f => f.fieldName || f.operator || f.value)
  const fieldLookup = useMemo(() => buildLookup(filterDefs), [filterDefs])
  const utilLookup = useMemo(() => buildLookup(utilDefs), [utilDefs])

  if (activeFilters.length === 0) return null

  return (
    <div className="flex items-center gap-1.5 flex-wrap mt-3">
      {activeFilters.map((f, i) => (
        <span key={i} className="inline-flex items-center gap-1.5 pl-2.5 pr-1.5 py-1 bg-gray-100 rounded text-xs text-text-primary">
          {formatFilterLabel(f, fieldLookup, utilLookup)}
          <button onClick={() => onRemove(i)} className="w-5 h-5 flex items-center justify-center rounded hover:bg-error-main/20 hover:text-error-main text-text-secondary text-base leading-none">&times;</button>
        </span>
      ))}
      {activeFilters.length >= 2 && (
        <button onClick={onClearAll} className="text-xs text-error-main hover:underline ml-1">
          Clear all
        </button>
      )}
    </div>
  )
}

export default AppliedFilters
